import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { mergeClasses } from '@/utils/style';
import { Headline } from '@/components/typography';
type SectionHeadlineProps = {
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  variant?: 'default' | 'inverted';
} & ({
  anchorKey: string;
  id?: string;
} | {
  id: string;
  anchorKey?: string;
});
export function SectionHeadline(props) {
  const $ = _c(11);
  const {
    className,
    children,
    as,
    variant,
    anchorKey,
    id
  } = props;
  const headlineAs = as || "h2";
  const t0 = variant === "inverted" ? "text-white" : "text-gray-900";
  let t1;
  if ($[0] !== className || $[1] !== t0) {
    t1 = mergeClasses("text-center px-4 lg:px-0", className, t0);
    $[0] = className;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== anchorKey || $[4] !== t1) {
    t2 = {
      variant: "h3" as const,
      className: t1,
      anchorKey,
      "data-analytics-param": "sectionHeader"
    };
    $[3] = anchorKey;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const headlineProps = t2;
  let t3;
  if ($[6] !== children || $[7] !== headlineAs || $[8] !== headlineProps || $[9] !== id) {
    t3 = <Headline as={headlineAs} {...headlineProps} id={id}>{children}</Headline>;
    $[6] = children;
    $[7] = headlineAs;
    $[8] = headlineProps;
    $[9] = id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}